<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        <a href="https://cognitox.org">@CognitoX</a>
      </div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
         <a href="mailto:admin@cognitox.org">admin@cognitox.org</a>
        </div>
      </div>
    </div>
  </div>
</footer>
